import api, { BASE_URL } from "../../api";

const PRODUCT_CATEGORY_BASE_URL = `${BASE_URL}/shop/admin/categories/`;

const listProductCategories = (context) => {
  return api(context)
    .get(PRODUCT_CATEGORY_BASE_URL + "?page_size=100")
    .then((response) => response.data);
};

const getProductCategory = (context, key) => {
  return api(context)
    .get(`${PRODUCT_CATEGORY_BASE_URL}${key}/`)
    .then((response) => response.data);
};

const updateProductCategory = (context, productCategory) => {
  return api(context)
    .patch(
      `${PRODUCT_CATEGORY_BASE_URL}${productCategory.key}/`,
      productCategory
    )
    .then((response) => response.data);
};

const insertProductCategory = (context, productCategory) => {
  return api(context)
    .post(PRODUCT_CATEGORY_BASE_URL, productCategory)
    .then((response) => response.data);
};

export const productCategory = {
  BASE_URL: PRODUCT_CATEGORY_BASE_URL,
  list: listProductCategories,
  get: getProductCategory,
  update: updateProductCategory,
  insert: insertProductCategory,
};

export default productCategory;
